import RewardsActive from "../../../Common/assets/icons/survey/rewards-active.svg?react";
import RewardsInactive from "../../../Common/assets/icons/survey/rewards-inactive.svg?react";
import RewardsVisited from "../../../Common/assets/icons/survey/rewards-visited.svg?react";
import AppExpActive from "../../../Common/assets/icons/survey/app-exp-active.svg?react";
import AppExpInactive from "../../../Common/assets/icons/survey/app-exp-inactive.svg?react";
import AppExpVisited from "../../../Common/assets/icons/survey/app-exp-visited.svg?react";
import MembershipActive from "../../../Common/assets/icons/survey/membership-active.svg?react";
import MembershipInactive from "../../../Common/assets/icons/survey/membership-inactive.svg?react";
import MembershipVisited from "../../../Common/assets/icons/survey/membership-visited.svg?react";

export const getSectionIcon = (
  iconType: "gift" | "mobile" | "membership",
  state: "active" | "inactive" | "visited"
) => {
  if (iconType === "gift") {
    if (state === "active") return RewardsActive;
    if (state === "visited") return RewardsVisited;
    return RewardsInactive;
  }
  if (iconType === "mobile") {
    if (state === "active") return AppExpActive;
    if (state === "visited") return AppExpVisited;
    return AppExpInactive;
  }
  // membership
  if (state === "active") return MembershipActive;
  if (state === "visited") return MembershipVisited;
  return MembershipInactive;
};

export const getSectionLabel = (iconType: "gift" | "mobile" | "membership") => {
  if (iconType === "gift") return "REWARDS";
  if (iconType === "mobile") return "APP EXPERIENCE";
  return "Membership";
};

